export const BankAccountTypeOptions = [
	{ id: "0", value: "普通", label: "普通" },
	{ id: "1", value: "当座", label: "当座" },
];
